import api from '@api';
import { call, put, takeEvery } from 'redux-saga/effects';
import {
    getUserNotificationsDetailFetchSuccess,
    getUserNotificationsDetailFetchFailure,
    updateUserNotificationsDetailFetchSuccess,
    updateUserNotificationsDetailFetchFailure,
} from './reducer';
import { UserNotificationsDetailResType } from 'src/types/userNotificationsDetail';
import { UserType } from 'src/types/user';
import translate from '@translate';

const getUserNotificationsDetailFetchRequest = async (idUser: string) => {
    const res = await api('get', `api/secure/users/notification/${idUser}`);
    return res.data;
};

function* getUserNotificationsDetailFetch(action: { type: string; payload: string }) {
    try {
        const response: UserNotificationsDetailResType = yield call((): any =>
            getUserNotificationsDetailFetchRequest(action.payload)
        );
        yield put(getUserNotificationsDetailFetchSuccess(response));
    } catch (error) {
        yield put(getUserNotificationsDetailFetchFailure({ error }));
    }
}

export function* getUserNotificationsDetailFetchWatch() {
    yield takeEvery('userNotificationsDetail/getUserNotificationsDetailFetch', getUserNotificationsDetailFetch);
}

const updateUserNotificationsDetailFetchRequest = async (params: { idUser: string; data: UserType }) => {
    const res = await api('put', `api/secure/users/notification/${params.idUser}`, params.data);
    return res.data;
};

function* updateUserNotificationsDetailFetch(action: { type: string; payload: { idUser: string; data: UserType } }) {
    try {
        const response: UserNotificationsDetailResType = yield call((): any =>
            updateUserNotificationsDetailFetchRequest(action.payload)
        );
        yield put(
            updateUserNotificationsDetailFetchSuccess({
                ...response,
                messageSuccess: { title: translate('users.message.userNotificationsUpdate') },
            })
        );
    } catch (error) {
        yield put(updateUserNotificationsDetailFetchFailure({ error }));
    }
}

export function* updateUserNotificationsDetailFetchWatch() {
    yield takeEvery('userNotificationsDetail/updateUserNotificationsDetailFetch', updateUserNotificationsDetailFetch);
}
